import {Badge} from '@mantine/core';
import {Invoice} from '../types.ts';

// FNP-324: Invoice.status doesn't exist on the schema yet (FNP-283 tracks it).
// Until then, derive a coarse status from invoiceUrl presence so the badge
// isn't blank on the detail page. Once status lands, switch to the real value.
type LegacyInvoice = Invoice & { status?: string };

const colorFor = (status?: string): string => {
    if (!status) return 'gray';
    const normalized = status.toUpperCase();
    if (normalized === 'PAID') return 'green';
    if (normalized === 'OPEN' || normalized === 'DRAFT') return 'blue';
    if (normalized === 'VOID' || normalized === 'UNCOLLECTIBLE') return 'red';
    return 'gray';
};

export const InvoiceStatusBadge = ({record}: { record: Invoice }) => {
    const status = (record as LegacyInvoice).status ?? (record.invoiceUrl ? 'ISSUED' : 'PENDING');
    return <Badge color={colorFor((record as LegacyInvoice).status)}>{status}</Badge>;
};
